import React from 'react'
import useSWR from 'swr'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import StatTile from '../../shared/StatTile'

export default withTranslation()(function POSStats({ t }) {
  const { data } = useSWR('pos')
  const devices = data?.data ?? []

  const active = devices.filter((device) => device.status === 'active').length
  const inactive = devices.length - active
  const unassigned = devices.filter((device) => !device.branch_id).length

  const pct = (count) => devices.length ? Math.round((count / devices.length) * 100) : 0

  return (
    <div className="grid gap-4 md:grid-cols-4 mb-5">
      <StatTile
        icon={UIcons.UilBuilding}
        label={t('pos.management.stats.total')}
        value={devices.length}
        caption={t('pos.management.stats.total_hint')}
        tone="primary"
      />

      <StatTile
        icon={UIcons.UilCheckCircle}
        label={t('pos.management.stats.active')}
        value={active}
        sub={`${pct(active)}%`}
        caption={t('pos.management.stats.active_hint')}
        tone="success"
      />

      <StatTile
        icon={UIcons.UilBuilding}
        label={t('pos.management.stats.inactive')}
        value={inactive}
        sub={`${pct(inactive)}%`}
        caption={t('pos.management.stats.inactive_hint')}
        tone="danger"
      />

      <StatTile
        icon={UIcons.UilDesktop}
        label={t('pos.management.stats.unassigned')}
        value={unassigned}
        caption={t('pos.management.stats.unassigned_hint')}
        tone="purple"
      />
    </div>
  )
})
